import { type Routes } from '@angular/router';
import { authGuard, pinUnlockGuard } from '@features/auth';
import { fullTabOnlyGuard } from '@shared/platform';
import { refCaptureGuard } from './ref-capture.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  { path: 'ref', canActivate: [refCaptureGuard], children: [] },

  {
    path: 'opened-in-tab',
    loadComponent: () =>
      import('@pages/opened-in-tab/opened-in-tab.page').then(m => m.OpenedInTabPage),
  },

  {
    path: 'auth',
    loadChildren: () => import('@pages/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: 'onboarding',
    // Seed creation/import never runs in the ephemeral popup or side panel.
    canActivate: [fullTabOnlyGuard],
    loadChildren: () => import('@pages/onboarding/onboarding.routes').then(m => m.onboardingRoutes),
  },

  {
    path: '',
    canActivate: [authGuard, pinUnlockGuard],
    // Preloaded in the extension build (SelectivePreloadStrategy) — the shell
    // chunk must be in before the dashboard child can preload.
    data: { preload: true },
    loadChildren: () => import('./app-shell.routes').then(m => m.shellRoutes),
  },
];
